<template>
  <div class="listado--encargo">
    <button class="btn btn-micro btn-warning" @click="openModal">Buscar Encargo</button>
    <hr>
    <vuestic-modal :large="true" ref="modalEncargos">
      <div slot="title">Buscar Encargo Por Código de Proveedor</div>
      <div class="form-group">
        <div class="input-group">
          <input type="text" v-model="codigo" placeholder="ingrese codigo proveedor" @change="getEncargos">
          <i class="bar"></i>
        </div>
      </div>
      <table class="table table-bordered table-striped table-warning">
        <thead>
        <tr>
          <th>FOLIO</th>
          <th>FECHA</th>
          <th>VENDEDOR</th>
          <th>ESTADO</th>
<!--          <th>USO VOUCHER</th>-->
          <th>CLIENTE</th>
          <th>ABONO</th>
          <th>TOTAL VENTA</th>
          <th>VENTA</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="encargos.length === 0">
          <td colspan="9">No hay items para mostrar...</td>
        </tr>
        <tr v-for="item in encargos">
          <td>{{item.folio}}</td>
          <td>{{item.fecha | date("DD-MM-YYYY HH:MM:ss")}}</td>
          <td>{{item.vendedor_nombre | upper}}</td>
          <td>{{item.estado | upper}}</td>
<!--          <td>{{item.opcionales.usoVoucher | usoVoucher}}</td>-->
          <td>{{item.cliente_nombre | upper}}</td>
          <td>{{item.opcionales.abono | currency}}</td>
          <td>{{item.opcionales.totalVenta | currency}}</td>
          <td>{{item.tipo_venta | upper}}</td>
          <td><i class="fa fa-eye" @click="push(item)"></i></td>
        </tr>
        </tbody>
      </table>
    </vuestic-modal>
  </div>
</template>

<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";

  export default {
    name: "ModalListadoEncargo",
    components: {VuesticModal},
    methods: {
      getEncargos() {
        this.$axios.get(`/ventas/encargos?codigoProveedor=${this.codigo}&ordenar_por=folio&orden=desc`)
          .then((response) => {
            if (response.status === 200)
              this.encargos = response.data.items
            else
              this.$swal("Alerta", "No se encontraron vouchers...", "warning")
          })
          .catch(console.error)
      },
      push(item) {
        this.$router.push({
          query: {
            venta_id: item.id
          },
          path: 'nueva'
        })
      },
      openModal() {
        this.$refs.modalEncargos.open()
      }
    },
    filters: {
      usoVoucher(bool) {
        return bool ? "USADO" : "SIN USAR"
      }
    },
    data() {
      return {
        codigo: "",
        encargos: []
      }
    }
  }
</script>

<style scoped>

</style>
